module.exports = __webpack_public_path__ + "img/check-circle-green.bfac5d89.svg";